angular.module("nuovoRespUtenza.components", []).component("nuovoRespUtenza", {
  templateUrl: "ng/components/nuovoRespUtenza/nuovoRespUtenza.html",
  bindings: {
    richiestePostVendita: "<",
  },
  controllerAs: "nuovoRespUtenzaCtrl",
  controller: function NuovoRespUtenza(
    $location,
    $modalService,
    $arcService,
    $RichiestePostVenditaService,
    $rootScope,
    $configService,
    $userService,
    $uniService,
    $portalService,
    validationService,
    $timeout,
    ResponsabileUtenzaPvDealer,
  ) {
    var self = this;

    self.$onInit = function () {
      self.mapInfo = "";
      self.nuovoRespUtenza = ResponsabileUtenzaPvDealer.build();
      self.ragioneSociale = $configService.getAppConfig().user.name;
      self.identifier = $configService.getAppConfig().user.identifier;
      self.checkDeclare = {
        selected: false,
      };
      self.channel = $portalService
        .resolveContextApplicationName(context)
        .split("_")[1];
      self.responsabileUtenzaPv = {
        numberCertificate: {
          otp: null,
          otpTransactionId: null,
          responseVerificaNumTel: null,
          channel: null,
        },
        dealer: {},
      };
      if (
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "NRU2" ||
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "M2"
      ) {
        self.popolateCheckListDownload();
        self.popolateCheckListUpload();
      }
      self.resumingInfo = true;
      self.mapInfo = "LBL_RESP_UTENZA_DOC";
      getDealerUser();
    };

    var getDealerUser = function () {
      $userService
        .getDealerUser()
        .then(function (user) {
          if (user) {
            self.dealerUser = user;
          }
          if (
            self.richiestePostVendita.metadata &&
            self.richiestePostVendita.metadata.responsabileUtenzaPv &&
            self.richiestePostVendita.metadata.responsabileUtenzaPv.dealer
          ) {
            self.nuovoRespUtenza =
              self.richiestePostVendita.metadata.responsabileUtenzaPv.dealer;
            self.checkDeclare.selected =
              self.richiestePostVendita.metadata.responsabileUtenzaPv.dealer.checkTitolari;
          }
          self.resumingInfo = false;
          self.handleChange(null, "getDealerUser");
          if (self.richiestePostVendita && self.richiestePostVendita.metadata && self.richiestePostVendita.metadata.responsabileUtenzaPv && self.richiestePostVendita.metadata.responsabileUtenzaPv.automaticNextStep) {
            self.next();
            self.showPageLoader = true;
          }
        })
        .catch(function (err) {
          self.resumingInfo = false;
          console.log(err);
        });
    };

    var retrieveStepInfo = function () {
      self.clearLabelInfo = true;
      $RichiestePostVenditaService
        .getStepInfo(
          self.richiestePostVendita.id,
          self.richiestePostVendita.viewIndex
        )
        .then(function (response) {
          if (response.success) {
            self.showMapInfo = response.showBeMessage;
            self.mapInfo = response.message;
            self.enabledLoader = false;
          }
          self.clearLabelInfo = false;
        })
        .catch(function (error) {
          console.log(error);
          self.enabledLoader = false;
          self.clearLabelInfo = false;
        });
    };

    self.getWizardMap = function (viewIndex) {
      if (
        $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        })
      ) {
        return $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        }).viewName;
      }
    };

    self.check = function (el) {
      el.selected = !el.selected;
      self.checkDeclare = el;
      self.handleChange(el.selected, "checkTitolari");
    };

    self.handleChange = function (value, prop) {
      self.nuovoRespUtenza[prop] = value;
      if (prop == "cf" && value) {
        value = value.toUpperCase();
      }
      if (
        self.nuovoRespUtenza.name &&
        self.nuovoRespUtenza.surname &&
        self.nuovoRespUtenza.cf
      ) {
        $timeout(function () {
          self.codiceFiscaleOk = validationService.checkCfWithName(
            self.nuovoRespUtenza.cf,
            self.nuovoRespUtenza.surname,
            self.nuovoRespUtenza.name
          );
        }, 500);
      }
      if (
        prop != "getDealerUser" &&
        self.richiestePostVendita.metadata &&
        self.richiestePostVendita.metadata.responsabileUtenzaPv &&
        self.richiestePostVendita.metadata.responsabileUtenzaPv.dealer
      ) {
        self.richiestePostVendita.metadata.responsabileUtenzaPv.dealer =
          self.nuovoRespUtenza;
      }
    };

    self.backValidity = function () {
      return self.getWizardMap(self.richiestePostVendita.viewIndex) !==
        "NRU1" || self.richiestePostVendita.readOnly
        ? true
        : false;
    };

    self.nextValidity = function () {
      if (
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "NRU1" ||
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "M1"
      ) {
        return (
          self.nuovoRespUtenza.name &&
          self.nuovoRespUtenza.surname &&
          self.nuovoRespUtenza.cf &&
          self.nuovoRespUtenza.tel &&
          self.codiceFiscaleOk &&
          self.checkDeclare.selected
        );
      } else if (
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "NRU2" ||
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "M2"
      ) {
        return self.enableUploadFile;
      }
    };

    self.next = function () {
      self.enabledLoader = true;
      self.responsabileUtenzaPv.numberCertificate.otp = null;
      if (
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "NRU1" ||
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "M1"
      ) {
        self.sendOtp("next");
      } else if (
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "NRU2" ||
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "M2"
      ) {
        $modalService.openModal("submitRequest");
      }
    };

    self.back = function () {
      self.enabledBackLoader = true;
      if (self.richiestePostVendita.readOnly) {
        $location.path("/");
      } else {
        $RichiestePostVenditaService
          .backStepPv(
            self.richiestePostVendita,
            self.richiestePostVendita.typeWf,
            self.richiestePostVendita.applicationName,
            true
          )
          .then(function (response) {
            self.richiestePostVendita = response;
            self.enabledBackLoader = false;
          })
          .catch(function (error) {
            console.log(error);
            self.enabledBackLoader = false;
          });
      }
    };

    self.sendOtp = function (loader) {
      if (loader == "next") {
        self.enabledLoader = true;
      } else {
        self.resendOtpLoader = true;
      }
      $uniService
        .certificaNumeroTelefono(self.nuovoRespUtenza.tel, self.channel)
        .then(function (response) {
          if (response.success) {
            self.transactionOtp =
              response.startMobileNumberCertification.context.transactionId;
            $rootScope.$broadcast("addAlert", {
              text: "OTP_SENT",
            });
            $modalService.openModal("modaleOtp");
            self.showPageLoader = false;
          } else {
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_SENDING_OTP",
            });
            $rootScope.$broadcast('cancel-timer');
            self.showPageLoader = false;
          }
          self.enabledLoader = false;
          self.resendOtpLoader = false;

        })
        .catch(function (error) {
          $rootScope.$broadcast('cancel-timer');
          self.enabledLoader = false;
          self.resendOtpLoader = false;
          console.log(error);
          self.showPageLoader = false;
        });
    };

    self.validateUser = function () {
      self.responsabileUtenzaPv.numberCertificate.otpTransactionId =
        self.transactionOtp;
      self.responsabileUtenzaPv.numberCertificate.channel = self.channel;
      self.responsabileUtenzaPv.dealer = self.nuovoRespUtenza;
      self.validateLoading = true;
      $RichiestePostVenditaService
        .checkRespUtenza(
          self.responsabileUtenzaPv,
          self.richiestePostVendita.id,
          self.richiestePostVendita.status
        )
        .then(function (response) {
          if (response.success) {
            if (response.goToHome) {
              $location.path("/");
            } else {
              self.enabledLoader = true;
              $modalService.closeModal("modaleOtp");
              $RichiestePostVenditaService
                .nextStepPv(
                  self.richiestePostVendita,
                  self.richiestePostVendita.typeWf,
                  self.richiestePostVendita.applicationName,
                  true
                )
                .then(function (response) {
                  self.richiestePostVendita = response;
                  if (
                    self.getWizardMap(self.richiestePostVendita.viewIndex) ==
                    "NRU2" ||
                    self.getWizardMap(self.richiestePostVendita.viewIndex) ==
                    "M2"
                  ) {
                    self.popolateCheckListDownload();
                    self.popolateCheckListUpload();
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  self.enabledLoader = false;
                });
            }
          } else {
            self.responsabileUtenzaPv.numberCertificate.otp = null;
            $rootScope.$broadcast('cancel-timer');
          }
          self.validateLoading = false;
        })
        .catch(function (error) {
          $rootScope.$broadcast('cancel-timer');
          self.validateLoading = false;
          console.log(error);
        });
    };

    self.popolateCheckListDownload = function () {
      self.restDownloadRunning = true;
      $arcService
        .downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
        .then(function (response) {
          self.listOfDocumentDownload = response.listDocuments;
          self.visibleDownloadChecklist = response.visible;
          self.restDownloadRunning = false;
          self.enabledLoader = false;
          var docsDownloaded =
            self.listOfDocumentDownload &&
            self.listOfDocumentDownload.every(function (element) {
              return element.downloaded == true;
            });
          if (docsDownloaded) {
            self.validityPage(true);
          }
        })
        .catch(function (error) {
          console.error(error);
          self.restDownloadRunning = false;
          self.enabledLoader = false;
        });
    };

    self.popolateCheckListUpload = function () {
      self.restUploadRunning = true;
      $arcService
        .uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
        .then(function (response) {
          self.listOfDocumentUpload = response.listDocuments;
          self.visibleUploadChecklist = response.visible;
          self.message = response.message;
          self.enabledLoader = false;
          self.restUploadRunning = false;
          if (!self.visibleUploadChecklist) {
            self.validityUpload(true);
          }
        })
        .catch(function (error) {
          console.error(error);
          self.restUploadRunning = false;
          self.enabledLoader = false;
        });
    };

    self.validityPage = function (validity) {
      self.enableNext = validity;
    };

    self.validityUpload = function (validity) {
      self.enableUploadFile = validity;
    };

    self.submitRequestPV = function () {
      self.submitLoader = true;
      $RichiestePostVenditaService
        .submitRequestPvNuovoRespUtenza(self.richiestePostVendita.id)
        .then(function (response) {
          if (response.success) {
            $modalService.closeModal("submitRequest");
            $rootScope.$broadcast("addAlert", {
              text: "REQUEST_PV_SUBMITTED",
            });
            $location.path("/");
          }
          self.validateLoading = false;
          self.submitLoader = false;
        })
        .catch(function (error) {
          console.log(error);
          self.submitLoader = false;
          self.validateLoading = false;
        });
    };

    self.sospendi = function () {
      self.suspendLoader = true;
      $RichiestePostVenditaService
        .suspendInstance(
          self.richiestePostVendita,
          self.richiestePostVendita.typeWf,
          self.richiestePostVendita.applicationName,
          true
        )
        .then(function () {
          $location.path("/");
          $modalService.closeModal("suspendInstance");
          self.suspendLoader = false;
        })
        .catch(function (err) {
          console.log(err);
          self.suspendLoader = false;
        });
    };

    self.closeModal = function (modal) {
      $modalService.closeModal(modal);
      self.enabledLoader = false;
    };
  },
});